export const AFFILIATE_SLUG = 'affiliate';

export const GIFT_GUIDES_SLUG = 'gift-guides';

export const HIDE_ADS_SLUG = 'action-no-ads';

export const HIDE_IN_POST_ADS_SLUG = 'action-no-in-post-ads';

export const HIDE_COMMENTS_SLUG = 'action-no-comments';

export const NO_INDEX_SLUG = 'action-noindex';

export const NO_NARRATIV_SLUG = 'action-no-narrativ';

export const SPONSORED_SLUG = 'sponsored-post';

export const BLOCK_SPOTIM_SLUG = 'action-block-from-spotim';
